/**
 * Timezone utility to get user's preferred timezone
 * Default is America/New_York (EST/EDT)
 */

export const getUserTimezone = () => {
    return localStorage.getItem('userTimezone') || 'America/New_York';
};

export const setUserTimezone = (timezone) => {
    localStorage.setItem('userTimezone', timezone);
};

